<template>
  <el-dialog
    :visible.sync="visible"
    title="添加工票"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="90%"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item label="合同编号：" prop="agreementCode">
            <el-input
              v-model="dataForm.agreementCode"
              placeholder="关联合同"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="员工：" prop="workerId">
            <CommonDrop
              v-model="dataForm.workerId"
              url="/trade/worker/list"
              :autoDefault="false"
            ></CommonDrop>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工序：">
            <CommonDrop
              ref="tecDrop"
              v-model="dataForm.technologyId"
              url="/trade/technology/list"
              :autoDefault="false"
              @change="technologyChange"
            ></CommonDrop>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工作时间：" prop="workDay">
            <el-date-picker
              v-model="dataForm.workDay"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择工作时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="收货仓库：" prop="storageId">
            <storages v-model="dataForm.storageId"></storages>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-table :data="dataForm.detailList" border style="width: 100%">
        <el-table-column
          type="index"
          width="50"
          label="行号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column label="品番号" prop="code" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.code'"
              :rules="detailRule.code"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input
                v-model="scope.row.code"
                placeholder="请输入品番号"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="品名" prop="name" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.name'"
              :rules="detailRule.name"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input
                v-model="scope.row.name"
                placeholder="请输入品名"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="颜色" prop="color" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.color'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input
                v-model="scope.row.color"
                placeholder="请输入颜色"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="规格" prop="size" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.size'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input
                v-model="scope.row.size"
                placeholder="请输入规格"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column
          label="产出量"
          header-align="center"
          align="center"
          width="160"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.count'"
              :rules="detailRule.count"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.count"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="单价"
          header-align="center"
          align="center"
          width="160"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.price'"
              :rules="detailRule.price"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.price"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import moment from "moment";
import CommonDrop from "@/components/CommonDrop";
import { moneyValidator } from "@/utils/validate";

export default {
  components: { CommonDrop },
  data() {
    return {
      id: "",
      visible: false,
      dataForm: {},
    };
  },
  computed: {
    technologyPrice() {
      if (!this.$refs.tecDrop || !this.$refs.tecDrop.currentOption) {
        return 0;
      }
      let p = this.$refs.tecDrop.currentOption.price || 0;
      return p;
    },
    detailRule() {
      return {
        name: [{ required: true, message: "请填写品名", trigger: "change" }],
        code: [{ required: true, message: "请填写品番号", trigger: "change" }],
        price: [
          { required: true, message: "请填写单价", trigger: "change" },
          { validator: moneyValidator, trigger: "change" },
        ],
        count: [
          { required: true, message: "请填写数量", trigger: "change" },
          {
            validator: function(rule, value, callback) {
              let n = parseInt(value);
              if (isNaN(n)) {
                callback(new Error("请输入正确的数量"));
              }
              callback();
            },
            trigger: "change",
          },
        ],
      };
    },
    dataRule() {
      return {
        technologyId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        agreementCode: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        workerId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        workDay: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        storageId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
      };
    },
  },
  watch: {
    "dataForm.agreementCode": {
      handler: function(newVal) {
        if (newVal) {
          this.getAgreement(newVal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    technologyChange() {
      if (this.dataForm.detailList && this.dataForm.detailList.length > 0) {
        this.dataForm.detailList.forEach((item) => {
          item.price = this.technologyPrice;
        });
      }
    },
    async getAgreement(code) {
      const { data: res } = await this.$http.get(
        `/trade/agreement/code/${code}`
      );
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      if (res.data && res.data.detailList && res.data.detailList.length > 0) {
        this.dataForm.detailList = res.data.detailList.map((item) => {
          return {
            code: item.code,
            name: item.name,
            productId: item.productId,
            color: item.color,
            size: item.size,
            count: 0,
            price: this.technologyPrice,
          };
        });
      }
    },
    reset() {
      this.dataForm = {
        workerId: "",
        productId: "",
        count: "",
        workDay: moment().format("yyyy-MM-DD"),
        agreementId: "",
        agreementCode: "",
        storageId: "",
        technologyId: "",
        detailList: [],
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.reset();
      this.visible = true;
      this.$nextTick(() => {
        if (this.id) {
          this.getInfo();
        }
      });
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/worklog/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
        })
        .catch(() => {});
    },

    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          const detailList = this.dataForm.detailList.filter(
            (item) => item.count > 0
          );
          if (detailList.length === 0) {
            return this.$message.error("请输入产量");
          }
          let postForm = [];
          detailList.forEach((item) => {
            postForm.push({
              agreementCode: this.dataForm.agreementCode,
              workerId: this.dataForm.workerId,
              productId: item.productId,
              count: item.count,
              workDay: this.dataForm.workDay,
              storageId: this.dataForm.storageId,
              technologyId: this.dataForm.technologyId,
              price: item.price,
            });
          });
          this.$http[!postForm.id ? "post" : "put"]("/trade/worklog/", postForm)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.cancel();
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    cancel() {
      this.visible = false;
    },
  },
};
</script>
